export const messages = {
  unsupportedConfiguration: 'The offer configuration is not supported for editing.',
  unsupportedDetailsConfiguration: 'The offer configuration is not supported for viewing.',
  viewOriginalOffer: 'View the original offer',
};
